import { LogicalFilter } from "@refinedev/core";
import { UseTableReturnType } from "@refinedev/react-table";

// Top-level boolean stored on the entity: Tina sets it true when it uploads the
// bundled placeholder, and an admin edit that replaces the artwork clears it to
// false. Synced verbatim Firestore→Typesense. We filter on this rather than a
// nested `media.photos.*` leaf: declaring any explicit nested field under
// media.photos makes Typesense project the photos array with only the declared
// leaves, dropping `url` and breaking backend deserialization.
const PLACEHOLDER_FIELD = "hasPlaceholderArt";

/**
 * Global "show only placeholder images" toggle for a Refine table (MOO-4468).
 *
 * When applied, filters the list to events/venues whose art is the bundled
 * Tina placeholder — useful for finding items that still need a real image.
 */
export const usePlaceholderFilter = (table: UseTableReturnType<any, any>) => {
  const toggle = (value: boolean) => {
    if (value) {
      table.refineCore.setFilters(
        [{ field: PLACEHOLDER_FIELD, operator: "eq", value: "true" }],
        "merge",
      );
    } else {
      table.refineCore.setFilters((prev) =>
        prev.filter((f) => (f as LogicalFilter).field !== PLACEHOLDER_FIELD),
      );
    }
  };

  const isApplied = table.refineCore.filters.some(
    (f) => (f as LogicalFilter).field === PLACEHOLDER_FIELD,
  );

  return { toggle, isApplied };
};
